export default [
    {
        path: 'relatorio-permissao-lotacao',
        component: () => import(/* webpackChunkName: 'administracao-relatorio-permissao-lotacao' */ '@/views/administracao/relatorio-permissao-lotacao/Index'),
        redirect: 'relatorio-permissao-lotacao/index',
        children: [
            {
                name: 'administracao-relatorio-permissao-lotacao-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'administracao-relatorio-permissao-lotacao' */ '@/views/administracao/relatorio-permissao-lotacao/List'),
            },
        ]
    }
]